import React, { PropTypes } from 'react';
import { Tabs, Modal, Input, Icon, Button, Upload, message, Spin } from 'antd';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import UserRoleStore from '../../stores/UserRoleStore';
import CreateNotificationsComponent from './notificationComponents/createNotificationsComponent'
import ViewClassesWithNotificationsComponent from './notificationComponents/viewClassesWithNotificationsComponent'
import ViewNotificationsOfClassComponent from './notificationComponents/viewNotificationsOfClassComponent'
const TabPane = Tabs.TabPane;
const { TextArea } = Input;

export default class NotificationsPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      classesWithNotificationsStatus: 0,
      activeKey: 'write'
    };

    if (!this.state.schoolId  && this.state.currentRole.associatName == "school") {
      this.state.schoolId = this.state.currentRole.associatObj.id;
    } else {
      this.state.schoolId = this.state.currentRole.associatObj.schoolId;
    }
    // bind this
    this.onRolesChange = this.onRolesChange.bind(this);
    this.onViewTabClick = this.onViewTabClick.bind(this);
  }

  componentDidMount(){
    UserRoleStore.addChangeListener(this.onRolesChange);
    let activeKey = localStorage.getItem('tabKey')
    if (activeKey) {
      this.setState({
        activeKey
      })
      localStorage.removeItem('tabKey');
    }
  }

  componentWillUnmount(){
    UserRoleStore.removeChangeListener(this.onRolesChange);
  }

  onRolesChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole(),
    });
  }

  onViewTabClick(activeKey) {
    this.setState({
      activeKey
    })
    if (activeKey == "view") {
      this.setState({
        classesWithNotificationsStatus: this.state.classesWithNotificationsStatus + 1,
      })
    }
  }

  render() {
    if (this.state.currentRole.associatName == "classRecord") { // common teacher, class admin
      return (
        <div className="notifications-page">
          <Tabs defaultActiveKey="write" onChange={this.onViewTabClick.bind(this)} activeKey={this.state.activeKey}>
            <TabPane tab="写通知" key="write">
              <CreateNotificationsComponent currentRole={this.state.currentRole} schoolId={this.state.schoolId} />
            </TabPane>
            <TabPane tab="查看已有通知" key="view">
              <ViewNotificationsOfClassComponent currentRole={this.state.currentRole} classId={this.state.currentRole.associatObj.id} />
            </TabPane>
          </Tabs>
        </div>
      )
    } else if (this.state.currentRole.associatName == "student") {
      return (
        <div className="notifications-page">
          <ViewNotificationsOfClassComponent currentRole={this.state.currentRole} classId={this.state.currentRole.associatObj.classId} />
        </div>
      )
    } else { // school admin, grade admin
      return (
        <div className="notifications-page">
          <Tabs defaultActiveKey="write" onChange={this.onViewTabClick.bind(this)} activeKey={this.state.activeKey}>
            <TabPane tab="写通知" key="write">
              <CreateNotificationsComponent currentRole={this.state.currentRole} schoolId={this.state.schoolId} />
            </TabPane>
            <TabPane tab="查看已有通知" key="view">
              <ViewClassesWithNotificationsComponent currentRole={this.state.currentRole} schoolId={this.state.schoolId} status={this.state.classesWithNotificationsStatus} activeKey={this.state.activeKey}/>
            </TabPane>
          </Tabs>
        </div>
      )
    }
  }
}






// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/classinfo/NotificationsPage.jsx